import {
  ChangeDetectorRef,
  EventEmitter,
  Component,
  OnDestroy,
  OnInit,
  AfterViewInit,
  Input,
  OnChanges,
  ChangeDetectionStrategy,
  ApplicationRef,
  Output
} from '@angular/core';
import {FormGroup, FormBuilder, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {CacheUtilService} from "../services/cache-util/CacheUtilService";
import {AuthService} from "../services/auth/AuthService";
import {TranslateService} from "../../../node_modules/ng2-translate/src/translate.service";
import {AlertService} from "../services/alert/alert.service";
import {UserVM} from "../models/UserVM";
import {LoginVM} from "../models/LoginVM";
import {Subscription} from "rxjs";
import {TimerObservable} from "rxjs/observable/TimerObservable";
import {CompanyService} from "../services/company-service/company-service";


//import {trigger,state,style,animate,transition} from '@angular/animations';

declare var smartWizardRef: any;


@Component({
  selector: 'register-form',
  template: require('./register.component.html'),
  styles: [require('./register.style.css')],
  //animations: [
  //  trigger('stepState', [
  //    state('inactive', style({
  //      backgroundColor: '#eee',
  //      transform: 'scale(1)'
  //    })),
  //    state('active',   style({
  //      backgroundColor: '#cfd8dc',
  //      transform: 'scale(1.1)'
  //    })),
  //    transition('inactive => active', animate('100ms ease-in')),
  //    transition('active => inactive', animate('100ms ease-out'))
  //  ])
  //]
  providers: [CacheUtilService, AuthService]

})

export class RegisterComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {

  public id;
  public baseurl: string = '';
  public doNotMatch;
  public error;
  public errorUserExists;
  public success;
  public errorEmailExists;
  public phoneNumberExists;
  public isPhonenumberValid: boolean = true;
  public registerAccount;
  public confirmPassword;
  public isEmailRequired:boolean=false;
  public emailTranslateParam = {value: '(اختیاری)'};

  public step = 1;
  public isClientEmailRequired;
  @Output()
  public onStepChanged: EventEmitter<number> = new EventEmitter();
  @Output()
  public onSuccessfulRegister: EventEmitter<UserVM> = new EventEmitter();
  private tick: number = 60;
  private canResendMessage = false;
  private subscription: Subscription;
  private activationCodeLenghtIsNotValid: boolean = false;
  keyUrl = "";

  constructor(public route: ActivatedRoute,
              public router: Router,
              public translate: TranslateService,
              private _cacheUtil: CacheUtilService,
              private authService: AuthService,
              private alertService: AlertService,
              private companyService: CompanyService) {

    this.doNotMatch = null;
    this.error = null;
    this.errorUserExists = null;
    this.success = null;
    this.registerAccount = new UserVM();

  }

  getState(stepNumber) {
    if (this.step == stepNumber) return "active";
    else return "inactive";
  }

  startTimer() {
    let parent = this;
    this.canResendMessage = false;
    this.tick = 60;
    if (this.subscription)
      this.subscription.unsubscribe();
    let timer = TimerObservable.create(2000, 1000);
    this.subscription = timer.subscribe(t => {
      if (this.tick > 0) {
        this.tick = this.tick - 1;
      } else {
        this.canResendMessage = true;
      }
    });
  }

  sendActivationCode() {
    let parent = this;
    this.isPhonenumberValid = this.phoneNumberIsValid();
    if (this.isPhonenumberValid)
    this.authService.sendActivationCode(parent.registerAccount.phoneNumber,this.keyUrl).then(function () {
      parent.step = 2;
      parent.onStepChanged.emit(parent.step);

      parent.registerAccount.activationCode = "";
      parent.startTimer();
      //  alert('done');
    }).catch(function (response) {
      // alert('error');
      parent.startTimer();
    });
    return false;

  }

  phoneNumberIsValid(): boolean {

    let pn = this.registerAccount.phoneNumber;
    return (pn && pn.length == 11 && pn > "0900000000");
  }

  confirmActivationCode() {
    let parent = this;
    if (parent.registerAccount.activationCode && parent.registerAccount.activationCode.length == 5) {
      this.authService.confirmActivationCode(parent.registerAccount.phoneNumber, parent.registerAccount.activationCode).then(function () {
        parent.step = 3;
        parent.onStepChanged.emit(parent.step);

      }).catch(function (response) {


      });
      this.activationCodeLenghtIsNotValid = false;
      parent.getCompanyInfo();
    }
    else {
      this.activationCodeLenghtIsNotValid = true;
    }
  }

  getCompanyInfo() {
    let parent = this;

    this.companyService.getCompanyInfo().subscribe((c) => {

      if(c && c.keyUrl)
        parent.keyUrl = c.keyUrl;

      parent.isClientEmailRequired = parent.companyService.getCompanyCustomSetting(c, 'isClientEmailRequired');
     // let el = document.getElementById('email') as HTMLElement;

      if (parent.isClientEmailRequired) {
        parent.isEmailRequired=true;
        this.emailTranslateParam = {value: ''};

       // el.removeAttribute('required');
      }
      if(!parent.registerAccount.email){
        parent.registerAccount.email = '';
      }
    })
  }


  resendActivationCode() {
    this.step = 1;
    this.onStepChanged.emit(this.step);
  }

  loadWizard() {
    smartWizardRef.makeWizard("smartwizard");
  }

  ngOnDestroy() {
    if (this.subscription)
      this.subscription.unsubscribe();
  }

  register() {
    let parent = this;
    this.registerAccount.login = this.registerAccount.phoneNumber;
    //if (this.registerAccount.password !== this.registerAccount.confirmPassword) {
    //  this.doNotMatch = 'ERROR';
    //} else {

    this.doNotMatch = null;
    this.error = null;
    this.errorUserExists = null;
    this.errorEmailExists = null;
    this.phoneNumberExists = null;
    if (this.isFormValid()) {
      this.authService.createAccount(this.registerAccount).then(function () {
        parent.success = 'OK';
        parent.onSuccessfulRegister.emit(parent.registerAccount);
        //   parent.router.navigateByUrl('activate/'+parent.registerAccount.login);
      }).catch(function (response) {
        parent.success = null;
        if (response.status === 400 && response._body === 'login already in use') {
          parent.errorUserExists = 'ERROR';
          parent.alertService.showErrorMessage('register.messages.error.userexists');
        } else if (response.status === 400 && response._body === 'e-mail address already in use') {
          parent.errorEmailExists = 'ERROR';
          parent.alertService.showErrorMessage('register.messages.error.emailexists');
        }
        else if (response.status === 400 && response._body === 'PhoneNumber already in use') {
          parent.phoneNumberExists = 'ERROR';
          parent.alertService.showErrorMessage('register.messages.error.phonenumberexists');
        }
        else {
          parent.error = 'ERROR';
          parent.alertService.showErrorMessage('register.messages.error.fail');
        }
      });
    }
    //}
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.getCompanyInfo();
  }

  isFormValid() {
    return true;

  }

  ngOnChanges(changes): void {
  }

}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/register/register.component.ts